import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LogDialogModule } from '@portal-core/logs/components/log-dialog/log-dialog.module';
import { GridModule } from '@portal-core/ui/grid/grid.module';
import { LogStreamGridComponent } from './log-stream-grid.component';

@NgModule({
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    GridModule,
    LogDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    RouterModule
  ],
  declarations: [
    LogStreamGridComponent
  ],
  exports: [
    LogStreamGridComponent
  ]
})
export class LogStreamGridModule { }
